import { Grid as MuiGrid, TextField } from '@mui/material';

import TabPanel from './TabPanel';

interface BasicInfoProps { 
    config: any; 
    activeTab: number;
    handleInputChange: (field: string, value: string) => void;
    configId: string;
}

export default function TabPanelBasicInfo(props: BasicInfoProps) { 
    const { config, activeTab, handleInputChange, configId } = props;
    return (
        <TabPanel value={activeTab} index={0}>
                        <MuiGrid container spacing={3}>
                          <MuiGrid item xs={12}>
                            <TextField
                              fullWidth
                              label="Classification ID"
                              value={config.config_id}
                              onChange={(e) => handleInputChange('config_id', e.target.value)}
                              disabled={configId !== 'new'}
                              required
                            />
                          </MuiGrid>
                          <MuiGrid item xs={12}>
                            <TextField
                              fullWidth
                              label="Name"
                              value={config.name}
                              onChange={(e) => handleInputChange('name', e.target.value)}
                              required
                            />
                          </MuiGrid>
                          <MuiGrid item xs={12}>
                            <TextField
                              fullWidth
                              label="Description"
                              value={config.description}
                              onChange={(e) => handleInputChange('description', e.target.value)}
                            />
                          </MuiGrid>
                        </MuiGrid>
                      </TabPanel>
    )
}